import styled from 'styled-components'
import { Relative, getPaletteColor } from 'pcln-design-system'

const BorderBox = styled(Relative)`
  border: solid ${getPaletteColor('border.base')} 1px;
`

export { BorderBox }
